import { useState } from 'react'
import { getPaymentMethods } from '../services/integrations'
import { useAuth } from '../modules/auth'

export interface PaymentMethod {
    id: string
    brand: string
    last4: string
    expMonth: number
    expYear: number
    holderName: string | null
    isPrimary: boolean
    isInUse: boolean
    createdAt: string
}

const useGetPaymentMethods = (): {
    methods: PaymentMethod[]
    getMethodsHandler: () => Promise<PaymentMethod[]>
    loading: boolean
} => {
    const [methods, setMethods] = useState<PaymentMethod[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const { currentUser } = useAuth()
    // currentUser may be undefined when this hook is mounted in an unauth
    // context (e.g. CheckoutForm during the signup flow). Guard the
    // destructure so the hook never throws — getMethodsHandler is still gated
    // by the caller, so we just won't fetch.
    const organizationId = currentUser?.organizationId
    const hasOrganization = currentUser?.hasOrganization

    const getMethodsHandler = async (): Promise<PaymentMethod[]> => {
        try {
            setLoading(true)
            const orgId = hasOrganization ? organizationId : undefined
            const res = await getPaymentMethods(orgId)
            const list: PaymentMethod[] = res?.data?.data?.paymentMethods ?? []
            setMethods(list)
            return list
        } catch (error) {
            return []
        } finally {
            setLoading(false)
        }
    }
    return { methods, getMethodsHandler, loading }
}

export default useGetPaymentMethods
